// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "EmailLogRow" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { EmailStatus } from "./email-status.enum.gen";

export const EmailLogRowGenShape = z.strictObject({
  id: z.string(),
  recipients: z.array(z.string()),
  subject: z.string().optional(),
  templateName: z.string().optional(),
  time: z.string(),
  status: z.enum(EmailStatus),
  message: z.string().optional(),
});
